import { Theme } from "../constants";

export default {
    accordion: {
        width: "100%",
        paddingLeft: "0px",
    },
    accordionItem: {
        listStyle: "none",
        width: "100%",
    },
    accordionToggle: {
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        padding: "12px 0px",
        borderWidth: "1px 0px",
        borderStyle: "solid",
        borderColor: Theme.PRIMARY_BORDER,
    },
    toggleIcon: {
        marginRight: "7px",
    },
    accordionContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        padding: "25px 0px",
    },
    accordionItemHeader: {
        fontWeight: "600",
        fontSize: "1rem",
        letterSpacing: "0.03em",
        marginBottom: "0px"
    },
    accordionItemColor: {
        color: Theme.TEXT_PRIMARY_BLACK,
    },
    accordionItemColorActive: {
        color: Theme.TEXT_PRIMARY,
    }
}